export const promptSuggestionsCategories = [
  {
    name: 'Validation',
    icon: 'validation',
    prompts: [
      {
        id: 'val_001',
        prompt: "Show a warning if the 'Buyer Name' isn't 'YOUR COMPANY NAME'",
      },
      {
        id: 'val_002',
        prompt:
          "Show an error and block confirmation if the 'Supplier VAT' matches one of our internal VAT IDs: ID1, ID2, ...",
      },
      {
        id: 'val_003',
        prompt:
          "If the 'Invoice Date' is more than 90 days in the past, show a warning to check the date.",
      },
      {
        id: 'val_004',
        prompt:
          "Display a warning message if the 'Delivery Date' falls on a weekend.",
      },
      {
        id: 'val_005',
        prompt:
          "If 'Invoice Date' is later than 'Due Date', show a warning about the unusual billing.",
      },
    ],
  },
  {
    name: 'Automation',
    icon: 'automation',
    prompts: [
      {
        id: 'auto_001',
        prompt:
          "If the 'Total Amount' is negative, automatically set the document status to 'Rejected'.",
      },
      {
        id: 'auto_002',
        prompt:
          'If invoice total amount is smaller than $20, automatically move set state to Export.',
      },
      {
        id: 'auto_003',
        prompt:
          'Stop automation and require review for any invoices dated before 2023.',
      },
      {
        id: 'auto_004',
        prompt:
          "If 'Subtotal' + 'Tax' = 'Total' and total smaller than $80, trust the numbers and push the document through, even with low confidence.",
      },
    ],
  },
  {
    name: 'Tagging',
    icon: 'tagging',
    prompts: [
      {
        id: 'tag_001',
        prompt:
          "If the 'PO Number' field is empty, apply the 'PO Not Matched' label.",
      },
      {
        id: 'tag_002',
        prompt:
          "When the 'Responsible Person ID' field is 'S-123', apply the 'JOHN DOW' label.",
      },
      {
        id: 'tag_003',
        prompt:
          "If 'Invoice Type' is 'Credit Note', add the 'Needs Review' label.",
      },
      {
        id: 'tag_004',
        prompt:
          'Add label "PRIORITY" if invoice arrives from email with domain \'@important.supplier.com\'',
      },
    ],
  },
  {
    name: 'Visibility',
    icon: 'visibility',
    prompts: [
      {
        id: 'vis_001',
        prompt:
          "Hide the 'Early Payment' section if the 'EPD Detected' field is empty.",
      },
      {
        id: 'vis_002',
        prompt:
          "Only show the 'Missing Line Item' field if the line items table is empty.",
      },
      {
        id: 'vis_003',
        prompt:
          "If the 'Currency' is 'USD', show the 'Tax-Exempt' dropdown selector field.",
      },
    ],
  },
  {
    name: 'Notify',
    icon: 'notify',
    prompts: [
      {
        id: 'notify_001',
        prompt:
          "If an invoice is over $10,000, send an email to 'approvals@company.com' for review.",
      },
      {
        id: 'notify_002',
        prompt:
          "When the 'Supplier VAT' is empty, send an email back to the supplier asking for a correction.",
      },
      {
        id: 'notify_003',
        prompt:
          "If a document is 'To Review' for more than 3 days, send a notification notifications@company.com",
      },
    ],
  },
] as const;
